/* react-bits port: LogoLoop (Animations/LogoLoop) -> vanilla marquee for the brand strip.
   Keeps the house rules: per-effect gating, prefers-reduced-motion fully static,
   pause on hover/focus, no theme-owned reveal classes touched. */
(function () {
  if (window.__pwLogoLoop) return;
  window.__pwLogoLoop = true;

  function init() {
    var strip = document.querySelector('.pw-brand-strip .pw-brand-links');
    if (!strip || strip.dataset.pwLoop === '1') return;
    strip.dataset.pwLoop = '1';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var items = Array.prototype.slice.call(strip.children);
    if (items.length < 4) return;

    // wrap originals in a track, clone once for a seamless loop
    var track = document.createElement('div');
    track.className = 'pw-loop-track';
    strip.parentNode.appendChild(track);
    track.appendChild(strip);

    var clone = strip.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.dataset.pwLoop = '1';
    track.appendChild(clone);

    strip.classList.add('pw-loop-list');
    clone.classList.add('pw-loop-list');

    // fade mask at both edges (react-bits fadeMask, smootherstep stops)
    var stops = [];
    for (var i = 0; i <= 12; i++) {
      var t = i / 12, s = t * t * t * (t * (t * 6 - 15) + 10);
      stops.push('rgba(0,0,0,' + s.toFixed(4) + ') ' + ((8 * i) / 12).toFixed(3) + '%');
    }
    for (var j = 12; j >= 0; j--) {
      var t2 = j / 12, s2 = t2 * t2 * t2 * (t2 * (t2 * 6 - 15) + 10);
      stops.push('rgba(0,0,0,' + s2.toFixed(4) + ') ' + (100 - (8 * j) / 12).toFixed(3) + '%');
    }
    track.style.webkitMaskImage = 'linear-gradient(to right,' + stops.join(',') + ')';
    track.style.maskImage = 'linear-gradient(to right,' + stops.join(',') + ')';

    // run the loop with rAF so hover can pause it cleanly
    var offset = 0, last = 0, paused = false, half = 0;
    function measure() { half = strip.scrollWidth; }
    measure();
    window.addEventListener('resize', measure);

    track.addEventListener('mouseenter', function () { paused = true; });
    track.addEventListener('mouseleave', function () { paused = false; });
    track.addEventListener('focusin', function () { paused = true; });
    track.addEventListener('focusout', function () { paused = false; });

    function frame(ts) {
      if (!last) last = ts;
      var dt = Math.min(64, ts - last) / 1000;
      last = ts;
      if (!paused && half > 0) {
        offset = (offset + dt * 42) % half; // 42px/s, calm retail pace
        track.style.transform = 'translateX(' + -offset + 'px)';
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
